<aw-wizard #wizard class="arc-wizard">
    <aw-wizard-step stepTitle="Escolha uma Área">
        <div class="row" style="padding: 20px;">
            <app-card [hidHeader]="true" [options]="false" class="col-sm-12">
                <div class="col-sm-12" align="center">
                    <h2>Escolha uma área para abordar com o paciente</h2>
                    <img id="main-logo" src="assets/images/area.png" alt="" width="78%" awNextStep>
                </div>
            </app-card>
            <div class="col-sm-12 centered-content">
                <div class="btn-group mt-10">
                    <button type="button" class="btn btn-primary btn-lg" awNextStep>Próximo</button>
                </div>
            </div>
        </div>
    </aw-wizard-step>
    <aw-wizard-step stepTitle="Estágio de Compemplação">
        <div class="row" style="padding: 20px;">
            <app-card [hidHeader]="true" [options]="false" class="col-sm-12">
                <h2>Qual o estágio de contemplação do paciente?</h2>
                <br>
                <div class="form-group d-inline">
                    <div class="radio radio-success d-inline">
                        <input type="radio" name="radio-s-in-1" id="radio-s-in-1" >
                        <label for="radio-s-in-1" class="cr">Pré-contemplação</label>
                    </div><br>
                    <div class="radio radio-success d-inline">
                        <input type="radio" name="radio-s-in-2" id="radio-s-in-2" >
                        <label for="radio-s-in-2" class="cr">Contemplação</label>
                    </div><br>
                    <div class="radio radio-success d-inline">
                        <input type="radio" name="radio-s-in-3" id="radio-s-in-3" >
                        <label for="radio-s-in-3" class="cr">Preparação</label>
                    </div><br>
                    <div class="radio radio-success d-inline">
                        <input type="radio" name="radio-s-in-4" id="radio-s-in-4" >
                        <label for="radio-s-in-4" class="cr">Ação</label>
                    </div><br>
                    <div class="radio radio-success d-inline">
                        <input type="radio" name="radio-s-in-5" id="radio-s-in-5" >
                        <label for="radio-s-in-5" class="cr">Manutenção</label>
                    </div><br>
                    <div class="radio radio-success d-inline">
                        <input type="radio" name="radio-s-in-6" id="radio-s-in-6" >
                        <label for="radio-s-in-6" class="cr">Recaída</label>
                    </div>
                </div>
            </app-card>
            <div class="col-sm-12 centered-content">
                <div class="btn-group mt-10">
                    <button type="button" class="btn btn-secondary btn-lg" awPreviousStep>Voltar</button>
                    <button type="button" class="btn btn-primary btn-lg" awNextStep>Próximo</button>
                </div>
            </div>
        </div>
    </aw-wizard-step>
    <aw-wizard-step stepTitle="Prévia da Jornada" >
        <div class="row" style="padding: 20px;">

            <app-card [hidHeader]="true" [options]="false" class="col-sm-12">
                <h3 align="center">COMO COMBATER A HIPERTENSÃO</h3> 
<br>
                <p><b>MÓDULO 1 - Introdução: </b>  Vídeo sobre as complicações da hipertensão.</p>
                <p><b>MÓDULO 2 - Mitos e Verdades:</b>  Jogo "Mitos e Verdades"</p>
                <p><b>MÓDULO 3 - Medicamentos</b> </p>
                <p><b>MÓDULO 4 - Atividade Física</b> </p>
                <p><b>MÓDULO 5 - Alimentação</b> : Jogo "Prato Saudável"</p>
                <p><b>MÓDULO 6 - Manejo do Estresse</b></p>
                <p><b>MÓDULO 7 - Relações Sociais</b> </p>
                <p><b>MÓDULO 8  - Sono</b></p>
                <p><b>MÓDULO 9  - Tabaco</b></p>
                <p><b>MÓDULO 10  - Álcool</b></p>
                <p><b>MÓDULO 11  - Outros Tóxicos</b></p>              
                
                
            </app-card>
           

            <div class="col-sm-12 centered-content">
                <div class="btn-group mt-10">
                    <button type="button" class="btn btn-secondary btn-lg" awPreviousStep>Voltar</button>
                    <button type="button" class="btn btn-primary btn-lg" awNextStep>Próximo</button>
                </div>
            </div>
        </div>
    </aw-wizard-step>
    <aw-wizard-step stepTitle="Forma de Envio">
        <div class="row" style="padding: 20px;">
            <div class="col-sm-12">
                <div class=""><br>
                    <app-card [hidHeader]="true" align="center">
                        <br>
                        <p align="center">
                            <button  type="button" class="btn btn-warning " style="margin-right: 30px;">
                                <i  class="feather icon-smartphone mr-2 f-20"></i>
                           
                                 Notificação no Aplicativo </button>
                        
                                <button  type="button" class="btn btn-success " >
                                    <i class="fab fa-whatsapp mr-2 f-24"></i>  Mensagem de Whatsapp </button>
                        </p>
                    </app-card>
                </div>
            </div>
            <div class="col-sm-12 centered-content">
                <div class="btn-group mt-10">
                    <button type="button" class="btn btn-secondary btn-lg" awPreviousStep>Voltar</button>
                    <!--<button type="button" class="btn btn-success btn-sm" awResetWizard>Finished</button>-->
                </div>
            </div>
        </div>
    </aw-wizard-step>
</aw-wizard>